import { render, staticRenderFns } from "./myRegister.vue?vue&type=template&id=6bb9bb1e&"
import script from "@viewJs/examRegisteation/myRegister.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/myRegister.js?vue&type=script&lang=js&"
import style0 from "./myRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports